import { Dictionary, ITypedDictionary } from '../Models/Dictionaries';
import { DescriptionDTO, IabLanguageModel } from '../Models/IabLanaguageModel';

const appendIabDescription = (name: string, iabData: ITypedDictionary<DescriptionDTO>, translations: Dictionary) => {
  Object.keys(iabData).forEach((key) => {
    translations[`${name}_name_${key}`] = iabData[key].name;
    translations[`${name}_description_${key}`] = iabData[key].description;
    translations[`${name}_legal_description_${key}`] = iabData[key].descriptionLegal;
  });
};

export class LanguageMapper {
  public static map(localLanguage: string, iabLanguage: string): Dictionary {
    const translations: Dictionary = {};
    const local = JSON.parse(localLanguage);

    Object.keys(local).forEach(function (key) {
      translations[key] = local[key];
    });

    if (iabLanguage != '') {
      const iab: IabLanguageModel = JSON.parse(iabLanguage);

      translations['stack_title_storage'] = iab.purposes['1'].name;
      translations['stack_title_ads'] = iab.stacks['42'].name;
      translations['stack_description_ads'] = iab.stacks['42'].description;
      translations['stack_title_third_party'] = `${translations['ec_stack3_title']}*`;
      translations['option_description_third_party'] = translations['ec_stack3_details'];

      appendIabDescription('option', iab.purposes, translations);
      appendIabDescription('purpose', iab.purposes, translations);
      appendIabDescription('feature', iab.features, translations);
      appendIabDescription('special_purpose', iab.specialPurposes, translations);
      appendIabDescription('special_feature', iab.specialFeatures, translations);
      appendIabDescription('legIntPurpose', iab.purposes, translations);
    }

    return translations;
  }
}
